{
  "archetype": "generic",
  "blockType": "cta-banner",
  "contentHash": "e16039b3bed7452209ad48e1c219537e64020004b12e98784917e2f41316a3fc",
  "description": "Simple full-width banner CTA with primary background color, short text on left, and button on right. Stacks on mobile.",
  "files": {
    "block": "block.cogo.json",
    "datasource": "datasource.cogo.json",
    "events": "events.cogo.json",
    "flow": "flow.cogo.json",
    "ui": "ui.cogo.json",
    "variables": "variables.cogo.json"
  },
  "generatedAt": "2026-04-25T02:24:03.448Z",
  "lifecycle": {
    "onMount": "ctaBannerMount"
  },
  "metadata": {
    "author": "cogo",
    "category": "cta",
    "id": "cta-banner",
    "qualityTier": "golden",
    "tags": [
      "cta",
      "banner",
      "full-width",
      "primary",
      "simple",
      "responsive"
    ]
  },
  "name": "cta-banner",
  "permissions": {
    "forkable": true,
    "remixable": true,
    "visibility": "public"
  },
  "schemaVersion": "4.0",
  "socialMetadata": {
    "commentCount": 0,
    "fireCount": 0,
    "forkCount": 0
  },
  "stateContract": {
    "inputSymbols": [],
    "localState": {},
    "outputSymbols": []
  },
  "type": "ui",
  "version": "2.0.0"
}
